import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Output,
} from '@angular/core';
import { groupBy, mapValues } from 'lodash';
import { strictValues } from '../../../cross-team-shared/misc-utils/strict-record';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { ObjectClassService } from '../../shared/misc-services/object-class.service';
import { TruncateDirective } from '../../shared/truncate/truncate.directive';

@Component({
  selector: 'h3-top-five-classes',
  imports: [TruncateDirective],
  templateUrl: './top-five-classes.component.html',
  styleUrl: './top-five-classes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopFiveClassesComponent {
  @Output() selectClass = new EventEmitter<string>();

  private readonly store = inject(TaskWorkspaceStore);
  private readonly objectClassService = inject(ObjectClassService);

  top5Classes = this.buildTop5Classes();

  private buildTop5Classes() {
    const { objects } = this.store.state();
    const classCount = mapValues(
      groupBy(
        strictValues(objects)
          .map((object) => object.class)
          .filter((className) =>
            this.objectClassService.isValidClass(className),
          ),
      ),
      (group) => group.length,
    );
    return Object.entries(classCount)
      .sort(([, countA], [, countB]) => countB - countA)
      .slice(0, 5)
      .map(([name]) => ({
        name,
        label: this.objectClassService.getClassLabel(name),
        color: this.objectClassService.getClassColor(name),
      }));
  }
}
